const mutableDate = date => new Proxy(date, {
    get(target, prop) {
        if (prop == 'toDate') {
            return () => target
        } else {
            return (...args) => {
                const d = new Date(target);
                d[prop](...args);
                return mutableDate(d);
            }
        }
    }
})

export default mutableDate;
